import {IconButton} from '@material-ui/core'
import {withStyles} from '@material-ui/core/styles'

const hover = {
  backgroundColor: 'transparent',
}
const styles = {
  colorPrimary: {
    '&:hover': hover,
  },
  colorSecondary: {
    '&:hover': hover,
  },
}

export default withStyles(styles, {name: 'LPCIconButton'})(IconButton)
